import { useForm } from '@mantine/form';
import { useEffect, useState } from 'react';
import {
	validateDate,
	validateEndDate,
	validateNotEmpty,
	validateNumber,
} from '../../../util/validation/commonValidation';
import type { UpsertAttendanceDto } from '../types/AttendanceDto';

const defaultAttendance: UpsertAttendanceDto = {
	startTime: undefined,
	endTime: undefined,
	id: '',
	branchId: '',
	tillNo: '',
	operatorId: '',
};

export function useUpsertAttendanceForm(
	attendance: UpsertAttendanceDto = defaultAttendance,
) {
	const [inputs, setInputs] = useState<UpsertAttendanceDto>(attendance);

	const [previousBranchId, setPreviousBranchId] = useState(
		attendance.branchId,
	);

	const form = useForm<UpsertAttendanceDto>({
		mode: 'uncontrolled',
		initialValues: attendance,
		validate: {
			startTime: (value) => validateDate(value, false),
			endTime: (value, values) => validateEndDate(value, false, values.endTime),
			branchId: (value) =>
				validateNumber(value, false, 0, 10000000, 'Branch', false),
			tillNo: (value) => validateNotEmpty(value, 'Till'),
			operatorId: (value) =>
				validateNumber(value, false, 0, 10000000, 'Operator', false),
		},
		onValuesChange: (v) => setInputs(v),
	});

	useEffect(() => {
		if (previousBranchId !== inputs.branchId) {
			form.setValues({ tillNo: '' });
		}

		setPreviousBranchId(inputs.branchId);
	}, [inputs.branchId]);

	return { form, inputs };
}
